import iconFontStyles from './icon-font.css?raw';
import { createReusableStylesheet } from '../reusable-stylesheet';

const iconFontReusableStylesheet = createReusableStylesheet(
  'trimble:tcweb-icon-font',
  iconFontStyles
);

export { iconFontReusableStylesheet };
